// extracted by mini-css-extract-plugin
export default {"container":"SortedEmojis_container__vbsZB"};